import { clsx } from 'clsx';
import { FC } from 'react';
import { IconOdometer } from 'src/general/Icons/IconOdometer';
import { IconPetrol } from 'src/general/Icons/IconPetrol';
import { IconTransmission } from 'src/general/Icons/IconTransmission';
import { SvgIcon } from 'src/general/Icons/SvgIcon.type';
import { formatNumber } from 'src/general/helpers/formatNumber';
import { BaseCarData } from 'src/types/Car.types';
import styles from './CarPriceCard.module.scss';

interface Props {
  carData: BaseCarData;
  className?: string;
}

const carDetails: {
  title: string;
  Icon: FC<SvgIcon>;
  valueKey: keyof BaseCarData;
  formatter?: (value: any) => string;
}[] = [
  {
    title: 'Odometer',
    Icon: IconOdometer,
    valueKey: 'kilometers',
    formatter: (value) => formatNumber(value, { append: ' km' }),
  },
  {
    title: 'Fuel type',
    Icon: IconPetrol,
    valueKey: 'fuelType',
  },
  {
    title: 'Transmission',
    Icon: IconTransmission,
    valueKey: 'transmission',
  },
];

export const CarPriceCardDetails: FC<Props> = ({ carData, className }) => (
  <dl className={clsx(styles.details, className)}>
    {carDetails.map(({ title, Icon, valueKey, formatter }) => (
      <div key={title} className={styles.detailItem}>
        <dt className={styles.detailTitle}>
          <Icon />
        </dt>
        <dd className={clsx(styles.detailValue, 'c-fw-normal', 'c-fs-caption')}>
          {formatter ? formatter(carData[valueKey]) : carData[valueKey]}
        </dd>
      </div>
    ))}
  </dl>
);
